<template>
  <div class="detailsDrawer">
    <!-- <el-button-group>
      <el-button type="primary">已确认</el-button>
      <el-button type="primary">转工单</el-button>
    </el-button-group> -->
    <el-descriptions title=""
      border
      :column="2"
      style="margin: 0 0 30px">
      <el-descriptions-item label="报警ID">
        {{ activeItem.alarmId }}
      </el-descriptions-item>
      <el-descriptions-item label="报警类型">{{
        activeItem.type
      }}</el-descriptions-item>
      <el-descriptions-item label="设备名称">
        {{ activeItem.deviceName }}
      </el-descriptions-item>
      <el-descriptions-item label="报警等级">
        {{ activeItem.alarmSeverity }}
      </el-descriptions-item>
      <el-descriptions-item label="设备区域/地址">
        {{ activeItem.location }}
      </el-descriptions-item>
      <el-descriptions-item label="报警条件">{{ activeItem.condition }}
      </el-descriptions-item>
      <el-descriptions-item label="当前状态">
        {{ activeItem.status }}
      </el-descriptions-item>
      <el-descriptions-item label="正常范围">
        {{ activeItem.range }}
      </el-descriptions-item>
      <el-descriptions-item label="报警时间">
        {{ activeItem.alarmEndTime }} - {{ endAlarmTime }}
      </el-descriptions-item>
    </el-descriptions>
    <template v-if="activeItem.type !== '设备离线'">
      <el-radio-group v-model="radio"
        size="small">
        <el-radio-button label="表格"></el-radio-button>
        <el-radio-button label="图表"></el-radio-button>
      </el-radio-group>
      <div v-if="radio == '表格'"
        style="margin: 10px 0">
        <el-table :data="tableData"
          stripe
          size="mini"
          style="width: 100%"
          border
          :header-cell-style="{
            'font-weight': 'bold',
            color: '#333',
            'background-color': '#F7F7F7',
          }">
          <el-table-column v-for="(v, i) in tableHead"
            :key="i"
            :prop="v.prop"
            :label="v.label"
            align="center"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 30]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          style="text-align: right; margin-top: 10px">
        </el-pagination>
      </div>
      <div v-if="radio == '图表'"
        class="chartsBox">
        <PublicEcharts id="'myCharts'"
          :chartsData="chartsData"
          :type="'lightLine'" />
      </div>
    </template>
  </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts.vue";
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  props: ["activeItem"],
  components: {
    PublicEcharts,
  },
  data() {
    return {
      radio: "表格",
      tableHead: [
        { label: "时间", prop: "time" },
        { label: "状态", prop: "state" },
      ],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      chartsData: {
        name: "",
        unit: "",
        xData: [],
        dataArr: [],
      },
      endAlarmTime: "",
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getTopList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTopList();
    },
    async getTopList() {
      this.tableData = [];
      let res = await api.getSAlarmDetailsTop({
        alarmId: this.activeItem.alarmId,
        alarmType: this.activeItem.type,
        page: this.currentPage - 1,
        pageSize: this.page.size,
      });
      if (res && res.data.code == 200) {
        this.endAlarmTime = dateFtt(
          "yyyy-MM-dd hh:mm:ss",
          new Date(res.data.data.endTs)
        );
        if (this.activeItem.type == "设备离线") return;
        this.page.total = res.data.data.detail.totalElements;
        this.tableData = res.data.data.detail.data;
        this.tableData.map((v) => {
          v.time = dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.ts));
          v.state = v.unit ? v.value + v.unit : v.value;
        });
      }
    },
    async getChartsList() {
      this.chartsData.xData = [];
      this.chartsData.dataArr = [{ name: "", data: [] }];
      this.chartsData.unit = "";
      this.chartsData.name = "";
      let res = await api.getSAlarmDetailsCharts({
        alarmId: this.activeItem.alarmId,
        alarmType: this.activeItem.type,
      });
      if (res && res.data.code == 200) {
        let data = res.data.data.detail;
        this.chartsData.unit = data[0].unit;
        this.chartsData.dataArr[0].name = data[0].name;
        data.map((v) => {
          this.chartsData.xData.push(
            dateFtt("yyyy-MM-dd hh:mm", new Date(v.ts))
          );
          this.chartsData.dataArr[0].data.push(v.value);
        });
      }
    },
  },
  created() {
    this.getTopList();
    if (this.activeItem.type !== "设备离线") {
      this.getChartsList();
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.detailsDrawer {
  width: 95%;
  margin: 0 auto;
  ::v-deep .el-descriptions {
    th {
      width: 120px;
    }
  }
  .chartsBox {
    height: 300px;
  }
}
</style>